(async () => {
  if (!customElements.get("product-media")) {
    const {
      default: Swiper,
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay,
    } = await import("swiper");
    const { Fancybox } = await import("@fancyapps/ui");

    Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

    class ProductMedia extends HTMLElement {
      constructor() {
        super();
        this.swiper();
        this.fancybox();
      }

      swiper() {
        // Check if Swiper exists
        if (typeof Swiper == "undefined") {
          return false;
        }

        // Get swiper element
        this.swiperElement = this.querySelector("[data-product-media-swiper]");

        // Swiper options
        this.swiperOptions = {
          direction: "horizontal",
        };

        // Get options from element data and combine with this.options
        if (this.swiperElement.dataset?.options) {
          const dataOptions = JSON.parse(this.swiperElement?.dataset.options);
          this.swiperOptions = {
            ...this.swiperOptions,
            ...dataOptions,
          };
        }

        // Init swiper
        this.swiperInstance = new Swiper(
          this.swiperElement,
          this.swiperOptions
        );

        this.handleWindowWidth();
        window.addEventListener("resize", () => this.handleWindowWidth());

        // Rebuid Swiper in design mode
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener("shopify:section:load", () => {
            this.swiperInstance.update();
          });
        }
      }

      /**
       * handleWindowWidth
       * @description Destroy or reinit the swiper based on breakpoint >= 1024
       */
      handleWindowWidth() {
        if (window.innerWidth >= 1024) {
          this.swiperInstance.destroy(true, true);
        } else {
          this.swiperInstance = new Swiper(
            this.swiperElement,
            this.swiperOptions
          );
        }
      }

      /*
       * Create fancybox
       */
      fancybox() {
        // Check if Fancybox exists
        if (typeof Fancybox == "undefined") {
          return false;
        }

        Fancybox.bind("[data-fancybox]", {
          animated: false,
          showClass: false,
        });
      }
    }

    window.ProductMedia = ProductMedia;

    customElements.define("product-media", ProductMedia);
  }

  if (!customElements.get("image-zoom")) {
    class ImageZoom extends HTMLElement {
      constructor() {
        super();
        this.imageZoomHolder = this.querySelector("[data-image-zoom-holder]");
        this.imageZoomHolder.addEventListener("mousemove", (event) => {
          this.updateZoom(event);
        });
        this.imageZoomHolder.addEventListener("mouseleave", () => {
          this.imageZoomHolder.style.backgroundImage = "unset";
        });
      }

      /**
       * updateZoom
       * @description Calculates the x and y position of the background image
       * @param {Object} event
       */
      updateZoom(event) {
        // Set image
        this.imageZoomHolder.style.backgroundImage = `url(${this.imageZoomHolder.dataset.backgroundImage})`;
        // Update position
        this.imageZoomHolder = event.currentTarget;
        var offsetX = event.offsetX
          ? (offsetX = event.offsetX)
          : (offsetX = event.touches[0].pageX);
        var offsetY = event.offsetY
          ? (offsetY = event.offsetY)
          : (offsetX = event.touches[0].pageX);
        var x = (offsetX / this.imageZoomHolder.offsetWidth) * 100;
        var y = (offsetY / this.imageZoomHolder.offsetHeight) * 100;
        this.imageZoomHolder.style.backgroundPosition = x + "% " + y + "%";
      }
    }

    window.ImageZoom = ImageZoom;

    customElements.define("image-zoom", ImageZoom);
  }
})();
